import { useEffect, useState } from "react";

export default function AcasaPage() {
  const imageList = [
    "IMG-20200525-WA001811.jpg",
    "IMG-20200525-WA0015.jpg",
    "image.png",
    "image2.jpg",
    "img.jpg",
    "img1.jpg",
    "img2.jpg",
    "img3.jpg",
    "SmartLab.jpg",
    "SmartLab1.jpg",
  ];
  const [images] = useState(imageList);
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    if (images.length === 0) return;
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [images]);

  return (
    <main className="max-w-7xl mx-auto px-4 py-8 bg-gray-50">
      {images.length > 0 && (
        <div className="w-full flex justify-center items-center">
          <div
            className="w-full max-w-4xl aspect-[16/6] bg-white border border-gray-200 overflow-hidden rounded-xl shadow-xl relative flex items-center"
            style={{ minHeight: "500px" }}
          >
            <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
              {images.map((_, index) => (
                <div
                  key={index}
                  className={`rounded-full transition-all duration-300 cursor-pointer ${
                    index === current ? "w-4 h-4" : "w-3 h-3"
                  }`}
                  style={{
                    backgroundColor:
                      index === current
                        ? "rgb(170,190,107)"
                        : "rgb(211,211,211)",
                    boxShadow:
                      index === current
                        ? "0 0 8px rgba(170,190,107,0.8)"
                        : "0 0 4px rgba(0,0,0,0.2)",
                  }}
                  onClick={() => setCurrent(index)}
                  aria-label={`Slide ${index + 1}`}
                ></div>
              ))}
            </div>
            {/* Left Arrow */}
            <button
              className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-80 rounded-full p-3 shadow-lg hover:bg-opacity-100 z-10"
              onClick={() =>
                setCurrent((current - 1 + images.length) % images.length)
              }
              aria-label="Previous"
            >
              <span className="text-2xl">&#8592;</span>
            </button>
            {/* Image */}
            <img
              src={`/carousel/${images[current]}`}
              alt={`carousel-${current}`}
              className="w-full h-full object-cover transition-all duration-700 mx-auto"
              style={{
                boxShadow: "0 4px 24px rgba(0,0,0,0.12)",
                borderRadius: "1rem",
              }}
            />
            {/* Right Arrow */}
            <button
              className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-80 rounded-full p-3 shadow-lg hover:bg-opacity-100 z-10"
              onClick={() => setCurrent((current + 1) % images.length)}
              aria-label="Next"
            >
              <span className="text-2xl">&#8594;</span>
            </button>
          </div>
        </div>
      )}

      <p className="text-gray-700 mt-5">
          Ne găsești la Liceul Tehnologic “Dr. Florian Ulmeanu” Ulmeni, Str.
          Petre Dulfu nr. 27, județul Maramureș.
        </p>

        <div className="w-full overflow-hidden rounded-lg shadow-lg mt-4">
          <iframe
            title="Harta Liceul Tehnologic Dr. Florian Ulmeanu Ulmeni"
            src="https://maps.google.com/maps?q=Liceul%20Tehnologic%20Dr.%20Florian%20Ulmeanu%20Ulmeni&t=&z=15&ie=UTF8&iwloc=&output=embed"
            className="w-full h-64 md:h-96 border-0"
            allowFullScreen
            loading="lazy"
          />
        </div>
    </main>
  );
}
